import styled from 'styled-components/macro';
import { AddressElement } from '@stripe/react-stripe-js';

export const LabelWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const StyledAddressElement = styled(AddressElement)`
  margin-bottom: 30px;
`;
